export default __webpack_public_path__ + "static/media/peeps@3x.684512f5.png";